'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of loading
 */ const Loading = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "76.8757",
                cy: "52.3289",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["800"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "69.5281",
                cy: "69.6531",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["700"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.2039",
                cy: "76.9988",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "34.3601",
                cy: "69.6531",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "27.0085",
                cy: "52.3289",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "34.3601",
                cy: "34.4832",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["200"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.2039",
                cy: "27.1335",
                r: "5.77417",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.Loading = Loading;
//# sourceMappingURL=Loading.cjs.map
